<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15.767"
        height="15.768"
        viewBox="-6.676 -0.329 15.767 15.768"
        class="me-2"
    >
        <path
            :fill="customColor"
            d="M1.218 2.979a1.05 1.05 0 0 1 .061 2.096h-.061A1.05 1.05 0 0 1 .199 3.997a1.05 1.05 0 0 1 1.019-1.018zm1.574 9.152H-.354a.52.52 0 0 1-.524-.519v-.007c0-.289.234-.524.524-.524h.523V7.174h-.523a.522.522 0 0 1-.524-.519V6.65c0-.29.234-.524.524-.524h2.097c.288 0 .522.232.523.521v4.438h.524a.523.523 0 0 1 .002 1.046z"
        />
        <path
            :fill="customColor"
            d="M1.208 15.439c-4.35 0-7.885-3.537-7.885-7.884S-3.139-.329 1.208-.329c4.346 0 7.883 3.537 7.883 7.884s-3.537 7.884-7.883 7.884zm0-14.302a6.424 6.424 0 0 0-6.419 6.419 6.424 6.424 0 0 0 6.419 6.417 6.426 6.426 0 0 0 6.418-6.417c0-3.54-2.88-6.419-6.418-6.419z"
        />
    </svg>
</template>

<script setup>
    import { DEFAULT_BUTTON_COLOR } from '~/utils/constants';

    defineProps({
        customColor: {
            type: String,
            required: false,
            default: DEFAULT_BUTTON_COLOR
        }
    });
</script>
